import { DecodedValueMap, StringParam } from 'use-query-params';
import ArrayParam from '../utils/ArrayParam';
import DateParam from '../utils/DateParam';

export const activitySearchFilterParams = {
    placeId: StringParam,
    themeSlugs: ArrayParam,
    targetAudiences: ArrayParam,
    companyId: StringParam,
};

export const activitySearchViewParams = {
    startDate: DateParam,
    endDate: DateParam,
    view: StringParam,
};

const activitySearchParams = {
    ...activitySearchFilterParams,
    ...activitySearchViewParams,
};

export default activitySearchParams;

export type ActivitySearchParams = Partial<DecodedValueMap<typeof activitySearchParams>>;
